import { render, staticRenderFns } from "./DeliveryDriverDetailView.vue?vue&type=template&id=1bc67e65&lang=pug&"
import script from "./DeliveryDriverDetailView.vue?vue&type=script&lang=js&"
export * from "./DeliveryDriverDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports